import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {currencySymbol, price} from "../../../../config/values";
import CurrencyFormat from "react-currency-format";
import Button from "@material-ui/core/Button/Button";
import Link from "@material-ui/core/Link/Link";
import { Link as ReactLink } from "react-router-dom";

class UserOrders extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'factor_number',
                editable: 'never',
                filtering: false,
                title: Translate.factor_number,
            },
            { title: Translate.totalCartPrice,
                field: 'total_price_payed',
                filterPlaceholder: Translate.search,
            },
            { title: Translate.totalDiscounts,
                field: 'total_discounts',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <Typography style={{color: "#38bf84"}}>{rowData.total_discounts}</Typography>

            },
            { title: Translate.status,
                editable: 'never',
                field: 'status',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "done" :
                        <Typography className="order_badge" style={{backgroundColor: "#38bf84"}}>{Translate.done}</Typography>
                    , "rejected":
                        <Typography className="order_badge" style={{backgroundColor: "#580808"}}>{Translate.rejected}</Typography>
                    , "sending":
                        <Typography className="order_badge" style={{backgroundColor: "#3867bf"}}>{Translate.sending}</Typography>
                    , "gathering":
                        <Typography className="order_badge" style={{backgroundColor: "#3899bf"}}>{Translate.gathering}</Typography>
                    , "not_payed":
                        <Typography className="order_badge" style={{backgroundColor: "#ee0e0e"}}>{Translate.not_payed}</Typography>
                    , "need_verification":
                        <Typography className="order_badge" style={{backgroundColor: "#fc771f"}}>{Translate.need_verification}</Typography>
                },
            },
            { title: Translate.created_at_factor,
                editable: 'never',
                filtering: false,
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'YYYY/M/D')}`}
                    </Typography>
            },
            {
                title: Translate.activity,
                field: 'activity',
                render: rowData =>
                    <>
                        <Button
                            color="primary"
                            size="small"
                            variant="outlined"
                            component={ReactLink}
                            to={`/order/view/${rowData.id}`}
                        >
                            {Translate.view}
                        </Button>
                        {
                            (rowData.status === "not_payed" || rowData.status === "need_verification") &&
                            <Button
                                className="mx-5"
                                onClick={() => this.handleRemoveItem(rowData.id)}
                                size="small"
                                style={{color:"#f82e4e",marginRight:5}}
                            >
                                {Translate.remove}
                            </Button>
                        }
                    </>
            }
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleRemoveItem(id){
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/factor/remove`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataRemoved, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.dataRemovingFailed, {
                    variant: 'error',
                });

            });

        this.setState({
            loading:false,
            SubmitLoading:false
        });
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className={!!this.props.widget ? "thin-table" : null}>
                            <MaterialTable
                                tableRef={this.tableRef}
                                icons={tableIcons}
                                title={" "}
                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/my-factors/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                            .then(response => {
                                                let data = [];
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        total_price_payed: price(row.total_price_payed) +" "+currencySymbol,
                                                        id: row.id,
                                                        factor_number: row.number,
                                                        total_discounts: price(row.total_discount_code_price + row.total_discount_price) +" "+currencySymbol,
                                                        status: row.status,
                                                        created_at: row.created_at,
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error.response)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    /*search:false,*/
                                }}
                            />
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(UserOrders)))));